import './index.css';

const Loader = () => {
	return (
		<div className="w-full h-full flex items-center justify-center">
			<div className="loadingio-spinner-rolling-jagnioo31n">
				<div className="ldio-m0qiozhbryl">
					<div></div>
				</div>
			</div>
		</div>
	);
};

export const Loader2 = () => {
	return (
		<div className="w-full h-full flex items-center justify-center">
			<div className="loadingio-spinner-wedges-nq4q5u6dq7r">
				<div className="ldio-x2uulkbinbj">
					<div>
						<div>
							<div></div>
						</div>
						<div>
							<div></div>
						</div>
						<div>
							<div></div>
						</div>
						<div>
							<div></div>
						</div>
					</div>
				</div>
			</div>
			<style type="text/css"></style>
		</div>
	);
};

export default Loader;
